<template>
  <div class="show_type_main">
    <!-- 1.图片按钮 TEMPLATE_BOTTOM_COL_SHOW_TYPE_BUTTON_IMAGE -->
    <div v-if="fModeObj.showType === 'TEMPLATE_BOTTOM_COL_SHOW_TYPE_BUTTON_IMAGE'" class="footer_header footer_header1">
      <el-divider class="divider1"></el-divider>
      <div class="fmHeader" v-if="fModeObj.firstLevelShow === 'STATUS_BOOL_TRUE'">
        <img
          class="header_img"
          v-if="fModeObj.languages[0]?.image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.image)"
          alt
        />
        <div class="footer_title">{{ fModeObj.languages[0]?.text }}</div>
      </div>
      <div class="footer_btn_image">
        <div v-for="(item, index) in fModeObj.child.slice(0, 6)" :key="index">
          <img
            class="btn_img"
            v-if="item?.languages[0]?.image"
            @click="clickBtnTxt(item, `101_25_${rowIndex}_${index}`)"
            v-lazy="$utils.returnImgUrl(item?.languages[0]?.image)"
            v-exposure="{
              eid: `101_25_${rowIndex}_${index}_${item.sid}`,
              oid: `101_25_${rowIndex}_${index}`,
              jump_value: item.jump,
            }"
            :data-id="`101_25_${rowIndex}_${index}_${item.sid}`"
            alt
          />
        </div>
      </div>
      <el-divider class="divider2"></el-divider>
    </div>

    <!-- 2.文本展示 TEMPLATE_BOTTOM_COL_SHOW_TYPE_SHOW_TEXT -->
    <div v-if="fModeObj.showType === 'TEMPLATE_BOTTOM_COL_SHOW_TYPE_SHOW_TEXT'" class="footer_header">
      <div class="fmHeader" v-if="fModeObj.titleShow === 'STATUS_BOOL_TRUE'">
        <img
          class="header_img"
          v-if="fModeObj.languages[0]?.image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.image)"
          alt
        />
        <div class="footer_title">{{ fModeObj.languages[0]?.text }}</div>
      </div>
      <div
        class="fncolor900 text_con"
        :class="fModeObj.titleShow === 'STATUS_BOOL_TRUE' ? 'text_con_mt' : ''"
        v-html="fModeObj.languages[0]?.context"
        v-exposure="{
          eid: `101_25_${rowIndex}_0`,
        }"
        :data-id="`101_25_${rowIndex}_0`"
      ></div>
    </div>

    <!-- 3.社媒展示 TEMPLATE_BOTTOM_COL_SHOW_TYPE_BRAND_SOCIAL -->
    <div v-if="fModeObj.showType === 'TEMPLATE_BOTTOM_COL_SHOW_TYPE_BRAND_SOCIAL'" class="footer_header">
      <div class="fmHeader" v-if="fModeObj.titleShow === 'STATUS_BOOL_TRUE'">
        <img
          class="header_img"
          v-if="fModeObj.languages[0]?.image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.image)"
          alt
        />
        <div class="footer_title">{{ fModeObj.languages[0]?.text }}</div>
      </div>
      <div class="icons-list">
        <img
          v-for="(item, index) in iconList"
          v-lazy="$utils.returnImgUrl(item.platformIcon)"
          alt
          @click="onLink(item.homePageLink, `101_25_${rowIndex}_${index}`)"
          v-exposure="{ eid: `101_25_${rowIndex}_${index}` }"
          :data-id="`101_25_${rowIndex}_${index}`"
          :key="index"
        />
      </div>
    </div>

    <!-- 4.文本按钮 TEMPLATE_BOTTOM_COL_SHOW_TYPE_BUTTON_TEXT -->
    <div v-if="fModeObj.showType === 'TEMPLATE_BOTTOM_COL_SHOW_TYPE_BUTTON_TEXT'" class="footer_header">
      <div class="fmHeader" v-if="fModeObj.firstLevelShow === 'STATUS_BOOL_TRUE'">
        <img
          class="header_img"
          v-if="fModeObj.languages[0]?.image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.image)"
          alt
        />
        <div class="footer_title">{{ fModeObj.languages[0]?.text }}</div>
      </div>
      <div :class="[getIsMobile ? 'flex-wrap' : '']">
        <template>
          <div v-for="(item, index) in fModeObj.child" class="fl text_moudle" :key="index">
            <img
              class="fl btn_txt_img"
              v-if="item.languages[0]?.image"
              v-lazy="$utils.returnImgUrl(item.languages[0]?.image)"
              alt
            />
            <span
              class="fl txt_span"
              :class="item.languages[0]?.image ? '' : 'txt_span_sup'"
              @click="clickBtnTxt(item, `101_25_${rowIndex}_${index}`)"
              v-exposure="{
                eid: `101_25_${rowIndex}_${index}_${item.sid}`,
                oid: `101_25_${rowIndex}_${index}`,
                jump_value: item.jump,
              }"
              :data-id="`101_25_${rowIndex}_${index}_${item.sid}`"
              >{{ item.languages[0]?.text }}</span
            >
          </div>
        </template>
      </div>
    </div>

    <!-- 5.图片展示 TEMPLATE_BOTTOM_COL_SHOW_TYPE_IMAGE -->
    <div v-if="fModeObj.showType === 'TEMPLATE_BOTTOM_COL_SHOW_TYPE_IMAGE'" class="footer_header">
      <div class="fmHeader" v-if="fModeObj.titleShow === 'STATUS_BOOL_TRUE'">
        <img
          class="header_img"
          v-if="fModeObj.languages[0]?.image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.image)"
          alt
        />
        <div class="footer_title">{{ fModeObj.languages[0]?.text }}</div>
      </div>
      <div
        v-if="getIsMobile"
        v-exposure="{
          eid: `101_25_${rowIndex}_0`,
        }"
        :data-id="`101_25_${rowIndex}_0`"
      >
        <img
          class="show_img"
          v-if="fModeObj.languages[0]?.h5Image"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.h5Image)"
          alt
        />
      </div>
      <div
        v-else
        v-exposure="{
          eid: `101_25_${rowIndex}_0`,
        }"
        :data-id="`101_25_${rowIndex}_0`"
      >
        <img
          class="show_img"
          v-if="fModeObj.languages[0]?.pcImage"
          v-lazy="$utils.returnImgUrl(fModeObj.languages[0]?.pcImage)"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isMobile } from "@/lobby_common/utils/utils.js";
import TelegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";

export default {
  name: "ShowType",
  props: {
    fModeObj: {
      type: Object,
      default: () => {},
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  async created() {},
  mounted() {},
  computed: {
    ...mapGetters(["brandDetail", "getIsMobile"]),
    iconList: function () {
      if (!this.brandDetail.socialPlatform) return [];
      return this.brandDetail.socialPlatform || [];
    },
  },
  methods: {
    onLink(url, oid) {
      this.$eventPost("click", {
        eid: oid,
        homePageLink: url,
        time: Date.now(),
      });
      if (isMobile()) {
        if (window?.Telegram?.WebApp?.openLink) {
          Telegram.WebApp.openLink(url);
        } else {
          TelegramUtil.hideBackButton();
          // window.open(url, "_self");
          locationJump(url, 2);
        }
      } else {
        window.open(url, "_blank");
      }
    },
    clickBtnTxt(obj, oid) {
      this.$eventPost("click", {
        eid: oid,
        jump_value: obj.jump,
        time: Date.now(),
      });
      if (obj.jump?.type === "Jump_TYPE_MULTIPLE_GAME") {
        if (obj.jump.multipleGame?.sid) {
          const item = { ...obj, bindType: 4 };
          localStorage.setItem("Cur_params", JSON.stringify(item));
          const flag = { flag: new Date().getTime() };
          // this.$router.push({ name: "homeSearch", query: flag });
          goJoinEvent(obj.jump);
        }
      } else {
        // 除了多款游戏其他跳转
        goJoinEvent(obj.jump);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.show_img {
  width: auto;
  max-width: 100%;
}

.footer_header {
  .flex-wrap {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .fl {
      flex: none;
      width: fit-content;
      margin-right: 20px;
    }
  }
}

.fncolor900 {
  color: var(--font-color-100);
}

.txt_span {
  color: var(--font-color-900);
  max-width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.txt_span:hover {
  color: var(--font-color-700);
}
.txt_span_sup {
  max-width: 100%;
}
.text_con {
  font-size: 12px;
  line-height: 20px;
}
::v-deep .text_con p {
  margin: 0;
}
.text_con_mt {
  margin-top: -10px;
}
.footer_header1 {
  .footer_btn_image {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .btn_img {
      height: 42px;
      cursor: pointer;
      // @media (max-width: 768px) {
      //   height: 20px;
      // }
    }
  }
}

.footer_header {
  overflow: hidden;
  margin: 0 auto;
  align-content: center;
  margin-bottom: 20px;
  .fmHeader {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    color: var(--font-color-900);
    @media (max-width: 768px) {
      margin-bottom: 15px;
    }
    .footer_title {
      font-size: 16px;
    }
    .header_img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  div.fl {
    flex: 1;
    text-align: left;
  }
  div.text_moudle {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 15px;
    @media (max-width: 768px) {
      margin-bottom: 5px;
    }
  }
  .btn_txt_img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }

  .icons-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      cursor: pointer;
      margin: 0 16px 10px 0;
    }
  }
  .icons-list::after {
    content: "";
    flex: auto;
  }
}
.divider1 {
  margin-top: 0px;
  background-color: var(--border-color-100) !important;
}
.divider2 {
  margin-bottom: 0px;
  background-color: var(--border-color-100) !important;
}

@media screen and (max-width: 512px) {
  div.text_moudle {
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .divider1 {
    background-color: var(--border-color-300) !important;
  }
  .divider2 {
    background-color: var(--border-color-300) !important;
  }
  .icons-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .grid-item {
      display: inline-block;
      img {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        cursor: pointer;
        margin: 4px 20px 4px 0;
      }
    }
  }
}
</style>
